import type { ComponentChildren, JSX } from 'preact';
import { ArrowRightIcon } from 'lucide-react';

type NativeButtonProps = JSX.IntrinsicElements['button'];

type ButtonProps = NativeButtonProps & {
  loading?: boolean;
  /** Pass `null` for no trailing icon; defaults to ArrowRight. */
  endIcon?: ComponentChildren;
  /** `secondary` is the undo/step-back treatment — same metrics, bordered instead of filled. */
  variant?: 'primary' | 'secondary';
};

export function Button({
  children,
  loading = false,
  endIcon,
  variant = 'primary',
  disabled,
  type = 'button',
  className,
  ...rest
}: ButtonProps) {
  const trailing = loading ? (
    <span className="sm-spinner" aria-hidden="true" />
  ) : endIcon !== undefined ? (
    endIcon
  ) : (
    <ArrowRightIcon className="sm-btn-arrow" size={16} aria-hidden="true" />
  );

  return (
    <button
      type={type}
      className={[
        'sm-control',
        'sm-center sm-btn',
        variant === 'secondary' ? 'sm-focus-ring sm-btn-secondary' : null,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {children}
      {trailing}
    </button>
  );
}
